import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    getRooms,
    getAdultsAndKids,
    showKidsErrors,
    isPrime,
    showKNonPrimeHotelKidsErrors,
    getAdultsAndKidsNonPrimeHotels,
    isHotelProductActive
} from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils/PageContext/index';
import { RoomsProps } from '../../models/index';
import { useVerifyHotelRooms } from './useVerifyHotelRooms';

const RoomSelector = ({
    value,
    hasError,
    trackEvent,
    render,
    pax,
    isPrime,
    hasNonPrimeHotelKidsErrors,
    nonPrimeHotelRoomsPax,
    isHotel,
}) => {
    const isNonPrimeHotel = isHotel && !isPrime;
    useVerifyHotelRooms(value, isNonPrimeHotel);
    const dynamicPax = isNonPrimeHotel ? nonPrimeHotelRoomsPax : pax;
    const dynamicValue = isNonPrimeHotel ? new Array(nonPrimeHotelRoomsPax.rooms) : value;
    return render({
        dynamicValue,
        hasError,
        trackEvent,
        dynamicPax,
        isPrime,
        hasNonPrimeHotelKidsErrors,
        nonPrimeHotelRoomsPax,
        isHotel,
    });
};

RoomSelector.propTypes = {
    render: PropTypes.func.isRequired,
    value: RoomsProps.isRequired,
    hasError: PropTypes.bool.isRequired,
    trackEvent: PropTypes.func.isRequired,
    isPrime: PropTypes.bool.isRequired,
    isHotel: PropTypes.bool.isRequired,
    hasNonPrimeHotelKidsErrors: PropTypes.bool.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    value: getRooms,
    hasError: showKidsErrors,
    pax: getAdultsAndKids,
    nonPrimeHotelRoomsPax: getAdultsAndKidsNonPrimeHotels,
    isPrime: isPrime,
    hasNonPrimeHotelKidsErrors: showKNonPrimeHotelKidsErrors,
    isHotel: isHotelProductActive,
});

export const ConnectedRoomSelector = connect(
    mapStateToPropsSelector,
    {},
)(withPageContext(RoomSelector));
